import Container from '../../../../core/components/atoms/Container';
import { Button } from '../../../../core/components/atoms/Button';
import { QuestionSection } from './components/questionsSection';
import { ContentSection } from './components/contentSection';
import { ReadySection } from './components/readySection';
import { useEffect, useState } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';
import { practiceConfigStore } from '../../stores/practiceConfigStore';
import { useStartPractice } from '../../hooks/startPractice';
import { useNavigate } from 'react-router-dom';
import { QuestionQuantitySection } from './components/questionsNumber';
import { ModalHowTo } from '../../components/ModalHowTo';
import { MinimalHeader } from '../../../../core/components/organism/MinimalHeader';
import { EssaySection } from './components/essaySection';
import { Modal } from '../../../../core/components/templates/Modal';

export function PracticeCreate() {
  const navigate = useNavigate();
  const { questionsNumber, error, hasCronometer, cronometer } = practiceConfigStore();
  const { mutate, data, isPending } = useStartPractice();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenHowTo, setIsOpenHowTo] = useState<boolean>(false);
  const [isOpenNoQuestions, setIsOpenNoQuestions] = useState<boolean>(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [isValidatingQuestions, setIsValidatingQuestions] = useState<boolean>(false);
  const [availableQuestions, setAvailableQuestions] = useState<number>(0);

  useEffect(() => {
    if (!data) return;

    if (data.ok && data.simulatedExamId) {
      navigate(`/simulados/simulado/${data.simulatedExamId}`);
      return;
    }

    setIsOpen(false);
    setErrors([]);
    setIsOpenNoQuestions(true);
  }, [data]);

  const onSubmit = () => {
    mutate();
  };

  const verifyErrors = () => {
    const newErrors = [...errors];

    if(hasCronometer && (!cronometer || cronometer === "")) {
      newErrors.push('Preencha o tempo de prova.')
    }

    if (
      !questionsNumber ||
      Number(questionsNumber) === 0 ||
      Number(questionsNumber) < 5
    ) {
      newErrors.push('O mínimo de questões é 5.');
    }

    if (Number(questionsNumber) > 90) {
      newErrors.push('O máximo de questões é 90.');
    }

    if (error) {
      newErrors.push(
        'Com base nos filtros não é possivel gerar um simulado com esta quantidade de questões.'
      );
    }

    setErrors(newErrors);
    setIsOpen(true);
  };

  const onClose = () => {
    setErrors([]);
    setIsOpen(false);
  };

  const breadcrumb = [
    {
      label: 'Simulador de provas',
      href: `/simulados/provas`,
    },
    {
      label: 'Criar simulado',
      href: `/simulados/criar`,
    },
  ];

  //TODO: Ver sobre chamar o verificador de questões sempre que houver alguma mudança nas configs (Melhoria)
  return (
    <Container gap='xxl' direction='col' className='xs:mb-[30px] xl:mb-[30px]'>
      <MinimalHeader
        action={() => setIsOpenHowTo(true)}
        actionText='Como funciona o Simulador?'
        breadcrumb={breadcrumb}
      />
      <ContentSection />
      <QuestionSection setAvailableQuestions={setAvailableQuestions} />
      <EssaySection />
      <QuestionQuantitySection setIsValidatingQuestions={setIsValidatingQuestions} availableQuestions={availableQuestions}/>
      <ReadySection />
      <Button className='m-auto' disabled={error || isValidatingQuestions} full onClick={() => verifyErrors()}>
        Gerar simulado
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={() => onClose()}
        position='center'
        className='p-0 xs:w-full lg:w-2/5'
      >
        <div className='flex flex-col gap-xl'>
          {errors.length > 0 &&
            errors.map((it, i) => (
              <Typography
                size='small'
                className='text-feedback-color-error-pure'
                key={i}
              >
                {it}
              </Typography>
            ))}
          <Typography>
            Tem certeza que deseja iniciar o simulado agora? Após o início, não
            será possível pausá-lo.
          </Typography>
          <div className='flex flex-row items-center justify-end gap-sm'>
            <Button variant='text' onClick={() => onClose()}>
              Voltar
            </Button>
            <Button
              variant='text'
              disabled={errors.length > 0}
              onClick={() => onSubmit()}
              loading={isPending}
            >
              Iniciar simulado
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isOpenNoQuestions}
        onClose={() => setIsOpenNoQuestions(false)}
        position='center'
        className='p-0 xs:w-full lg:w-2/5'
      >
        <div className='flex flex-col gap-xl'>
          <Typography>
            Não foi possível gerar um simulado com os filtros selecionados. Por favor, altere os filtros e tente novamente.
          </Typography>
          <div className='flex flex-row items-center justify-end gap-sm'>
            <Button variant='text' onClick={() => setIsOpenNoQuestions(false)}>
              Fechar
            </Button>
          </div>
        </div>
      </Modal>
      <ModalHowTo isOpen={isOpenHowTo} onClose={() => setIsOpenHowTo(false)} />
    </Container>
  );
}
